import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=148e6fa2&scoped=true"
import script from "./storage.vue?vue&type=script&lang=js"
export * from "./storage.vue?vue&type=script&lang=js"
import style0 from "./storage.vue?vue&type=style&index=0&id=148e6fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148e6fa2",
  null
  
)

export default component.exports